import { Card, Layout, message, Steps, Typography } from 'antd';
import { BaseLayoutComponent } from '@components';

const { Text } = Typography;

const { Content } = Layout;

export const OrderCompletePageComponent = () => {
    return (
        <>
            {/* {contextHolder} */ }
            <BaseLayoutComponent children={
                <Content className='m-5 bg-white border rounded-lg'>
                    <Steps
                        style={ { marginTop: 20 } }
                        progressDot
                        current={ 5 }
                        items={ [
                            {
                                title: 'Customer Information',
                            },
                            {
                                title: 'Order Details',
                            },
                            {
                                title: 'Product Information',
                            },
                            {
                                title: 'Delivery Information',
                            },
                            {
                                title: 'Guarantor Information',
                            },
                            {
                                title: 'Complete',
                            },
                        ] }
                    />
                    <Card
                        style={ { height: 400, justifyContent: 'center', display: 'flex' } }
                    >
                        <Text type='success' underline strong style={ { fontSize: 40, marginTop: 40 } }>Order have been
                            successfully created!</Text>
                    </Card>
                </Content>
            }
            />
        </>
    );
};